import '@angular/localize/init';
export * from './lib/feature-tax-allowance-list.module';

export * from './lib/tax-allowance-list/feature-tax-allowance-list.component';
